import * as React from 'react';
import { constants } from '../../constants/index';
import PText from 'components/Primatives/PText';
import moment from 'moment-timezone';
import { convertUtcToUserTimezone } from 'utils/timezoneUtils';
import { getActivePeriodTimestampsWithProgress } from 'utils/serviceUtils';

// COMPONETS
import ConditionalScrollList from 'components/Lists/ConditionalScrollList'



const ServiceDate = (props) => {
    
    const activePeriodsInfo = getActivePeriodTimestampsWithProgress(props.activePeriods);

    let activePendingServiceCount = 0;
    { activePeriodsInfo && activePeriodsInfo.length > 0 &&
        activePeriodsInfo.map(activePeriodInfo => {
            if ((activePeriodInfo.activePeriodPercentage >= 0) && (activePeriodInfo.activePeriodPercentage < 100)){
                return activePendingServiceCount ++;
            }
        });
    }

    // console.log('ServiceDate-activePeriodsInfo', activePeriodsInfo)
    // console.log('ServiceDate-activePendingServiceCount', activePendingServiceCount)
    return (
        <ConditionalScrollList conditionalScrollCount={activePendingServiceCount}>
            { activePeriodsInfo && activePeriodsInfo.length > 0 &&
                activePeriodsInfo.map(activePeriodInfo => {
                    // console.log('ServiceDate-activePeriodInfo', activePeriodInfo)
                    const activePeriodLocalStart = convertUtcToUserTimezone(activePeriodInfo.activePeriodStart)
                    if ((activePeriodInfo.activePeriodPercentage >= 0) && (activePeriodInfo.activePeriodPercentage < 100)){
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    width: '100%',
                                    paddingTop: 15
                                }}
                            >
                                <PText altColor style={{marginBottom: 5, fontSize: '1.4rem',}}>Appointment Day</PText>
                                <PText 
                                    style={{ marginBottom: 15, marginTop: 0 }}
                                    color='#818181'
                                    fontSize='1.4rem'
                                >
                                    { moment(activePeriodLocalStart, 'x').format('dddd, MMMM Do') }
                                </PText>
                            </div>
                        )
                    }
                })
                    
            }
        </ConditionalScrollList>
    ); 
};

export default ServiceDate;


// WEBPACK FOOTER //
// ./src/js/components/ServiceCardList/ServiceDate.jsx